import Constant from '@/const';
import axios from 'axios';

const addDrugSales = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/drugssales/add'),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default addDrugSales;
